import React from 'react';

import CastCard from '../CastCard';

import './CastList.scss';

import { ICrewMember } from '../../utils/models';
export interface ICastListProps {
  cast: ICrewMember[];
}

// We don't want to show cast card if the member has these roles
const rolesToHide = new Set(['EXECUTIVE_PRODUCER', 'PRODUCER', 'OTHER']);

const CastList = ({ cast }: ICastListProps) => {
  const topMembers = [...cast]
    .splice(0, 6)
    .filter((person) => !rolesToHide.has(person?.role));

  const members = topMembers.map((member) => (
    <li className="cast-list__item" key={member?.personId}>
      <CastCard member={member} />
    </li>
  ));

  return <ul className="cast-list">{members}</ul>;
};

export default CastList;
